<template >
  <b-container fluid>
    <!-- <b-row>
      <b-col class="bg-title">
        <h4><font color="ffffff">Generación de Reportes</font></h4>
      </b-col>
    </b-row>-->
    <b-row align-h="center">
      <b-col cols="11" sm="11" md="11" lg="11" xl="11"  class="card-form-primary mt-5 ">
        <b-row align-h="between" @click="isFormCollapse=!isFormCollapse" style="cursor:pointer;">
          <b-col class="mt-3 mb-2">
            <h5 style="color:#312bb5; text-transform:capitalize;"><b-icon icon="files"/> Generación de Reportes</h5>
            <!-- <h6 style="color: gray; text-transform:capitalize;">{{formasFormModel.inSelectTipoBusqueda.model.toLowerCase()}}</h6> -->
          </b-col>
          <b-col class="mt-3" cols="2" md="1" v-if="isFormCollapse">
              <b-icon style="color:#312bb5; cursor:pointer;" font-scale="1.3" shift-v="-3" icon="chevron-compact-down" />
          </b-col>
          <b-col class="mt-3" cols="2" md="1" v-if="!isFormCollapse">
              <b-icon style="color:#312bb5; cursor:pointer;" font-scale="1.3" shift-v="-3" icon="chevron-compact-up"/>
          </b-col>
        </b-row>
        <ReportesForm class="mt-3 mb-4" v-if="!isFormCollapse"/>
      </b-col>
    </b-row><br>
    <b-row align-h="center">
      <!---  Pdf ---->
      <b-col cols="12" sm="11" v-if="reporte!=null && reporte.pdf!=null">
        <vue-pdf-app  v-if="reporte.pdf!=null" :config="configPdf"  :pdf="'data:application/pdf;base64,' + reporte.pdf"></vue-pdf-app>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
      </b-col>

       <!----- Csv ------>
      <b-col cols="6" v-if="reporte!=null && reporte.csv!=null" class="mt-5">
        <b-button size="sm" variant="info" @click="descargarCsv">Descargar CSV <b-icon icon="file-earmark-spreadsheet" font-scale="1.1"/></b-button>
      </b-col>

       <!----- Excel ------>
      <b-col cols="6" v-if="reporte!=null && reporte.xls!=null" class="mt-5">
        <b-button block size="sm" variant="info" @click="descargarExcel">Descargar Excel <b-icon icon="file-earmark-spreadsheet" font-scale="1.1"/></b-button>
      </b-col>

      <!----- Zip ------>
      <b-col cols="6" v-if="reporte!=null && reporte.zip!=null" class="mt-5">
        <b-button block size="sm" variant="info" @click="descargarZip">Descargar Reporte <b-icon icon="file-earmark-spreadsheet" font-scale="1.1"/></b-button>
      </b-col>
     
     <!----- Sin resultados ------>
      <b-col cols="11" v-if="reporte==null || reporte.length==0" class="mt-5 ml-10">
        <h5 style="color:gray;"><b>Sin resultados</b></h5>
      </b-col>
      
    </b-row>

    <b-row align-h="center">
      <!---  Meta ---->
      <b-col cols="6" class="mt-3" >
        <h6 style="color:gray" v-if="reporte!=null && reporte.meta!=null && reporte.meta.fechaCorte!=null">Generado el {{reporte.meta.fechaCorte}}</h6>
      </b-col>
    </b-row>
    
    <!--
    <b-row align-h="start">
      <b-col xl="6" lg="8">
        <line-chart></line-chart>
      </b-col>
    </b-row>
    <b-row align-h="start">
      <b-col xl="6" lg="8">
        <bar-chart class="bar"></bar-chart>
      </b-col>
    </b-row>
    <b-row align-h="start">
      <b-col xl="6" lg="8">
        <pie-chart class="pie"></pie-chart>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="12">
        <ReportesTable/>
      </b-col>
    </b-row>
    -->
  </b-container>
</template>

<script>
import { mapState} from 'vuex';
  import ReportesForm from '@/components/reportes/ReportesForm.vue';
  //import ReportesTable from '@/components/reportes/ReportesTable.vue';
  //import LineChart from '@/components/reportes/LineChart';
  //import BarChart from '@/components/reportes/BarChart';
  //import PieChart from '@/components/reportes/PieChart';
  import VuePdfApp from "vue-pdf-app";
  // import this to use default icons for buttons
  import "vue-pdf-app/dist/icons/main.css";

  export default {
    computed: mapState ({
      reporte: state => state.reportes.reporte,
    }),
    components: {
      ReportesForm,
    //  ReportesTable,
     // LineChart,
      //BarChart,
      //PieChart,
      VuePdfApp
    },
    data() {
      return {
        configPdf:{
          toolbar:{
            toolbarViewerRight:{
              openFile:false
            }
          }
        },
        isFormCollapse:false
      }
    },
    mounted(){
      if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);

      }
      window.scrollTo(0, 0);
    },
    methods: {
        descargarExcel(){
          var data= 'data:application/pdf;base64,'+this.reporte.xls;              
          var downloadExcel = document.createElement('a');
          downloadExcel.setAttribute('href', data);
          downloadExcel.setAttribute('download', "reporte.xls");
          downloadExcel.click();  
        },
        descargarCsv(){
          var data= 'data:application/pdf;base64,'+this.reporte.csv;              
          var downloadCsv = document.createElement('a');
          downloadCsv.setAttribute('href', data);
          downloadCsv.setAttribute('download', "reporte.csv");
          downloadCsv.click();  
        },
        descargarZip(){
          var data= 'data:application/zip;base64,'+this.reporte.zip;              
          var downloadZip = document.createElement('a');
          downloadZip.setAttribute('href', data);
          downloadZip.setAttribute('download', "reporte.zip");
          downloadZip.click();  
        }
    }
  }
</script>
<style>
.pie{
  margin-top:20%;
}
.bar{
  margin-top:20%;
}
.polar{
  margin-top:20%;
}
</style>